<div class="ml-20px mt-20px">
  Primary
  <!-- Buttons used in unit test 'example-buttons.component.test.ts'-->
  <button ui-button id="disabled" buttonSize="small" buttonType="primary" [disabled]="true" (click)="disabledClick()">Primary disabled</button>
  <button ui-button id="loading" buttonType="primary" (click)="loadingClick()" [buttonLoading]="true">Primary loading</button>
  <button ui-button id="enabled" buttonSize="large" buttonType="primary" (click)="enabledClick()">Primary</button>
</div>

<div class="ml-20px mt-20px">
  Danger
  <button ui-button buttonType="primary" [buttonDanger]="true" [disabled]="true" buttonSize="small">Primary disabled small</button>
  <button ui-button buttonType="primary" [buttonDanger]="true" [buttonLoading]="true">Loading</button>
  <button ui-button buttonType="primary" [buttonDanger]="true" buttonSize="large">Primary large</button>
  <button ui-button [buttonDanger]="true" buttonSize="large">Not primary large</button>
</div>
<div class="ml-20px mt-20px">
  Default
  <button ui-button [disabled]="true" buttonSize="small">disabled small</button>
  <button ui-button [buttonLoading]="true">Loading</button>
  <button ui-button buttonSize="large">Large</button>
</div>
<div class="ml-20px mt-20px">
  Rounded
  <button ui-button buttonShape="round" buttonType="primary" buttonSize="small" [disabled]="true">Disabled</button>
  <button ui-button buttonShape="round" buttonType="primary" [buttonLoading]="true">Loading</button>
  <button ui-button buttonShape="round" buttonType="primary" buttonSize="large">Primary</button>
</div>
<div class="ml-20px mt-20px">
  <ui-button-group id="btn-group" uiSize="large">
    <button ui-button>
      <ui-icon uiType="outline:arrow-left"></ui-icon>
      Previous
    </button>
    <button ui-button>Today</button>
    <button ui-button>
      Next
      <ui-icon uiType="outline:arrow-right"></ui-icon>
    </button>
  </ui-button-group>
</div>

<!-- These buttons are breaking the unit tests ('example-buttons.component.test.ts')
  Examples of buttons only with icons -->
<!-- <div class="ml-20px mt-20px">
  With icons:
  <button ui-button buttonShape="round" buttonType="primary" buttonSize="large">
    <ui-icon uiType="fill:phone"></ui-icon>
    Call
  </button>
  <button ui-button buttonShape="round" buttonType="primary" [buttonDanger]="true" buttonSize="large">
    Power off
    <ui-icon uiType="outline:poweroff"></ui-icon>
  </button>
  <button ui-button>
    <ui-icon uiType="outline:logout"></ui-icon>
  </button>
</div> -->
